import {
  createContext,
  useState,
  useContext,
  useEffect,
  type ReactNode,
} from "react"

function useBannerState() {
  return useState<ReactNode | null>(null)
}
const TopBannerContext = createContext<ReturnType<typeof useBannerState>>([
  null,
  () => {},
])

export const TopBannerProvider = ({ children }: { children: ReactNode }) => {
  const bannerState = useBannerState()
  return (
    <TopBannerContext.Provider value={bannerState}>
      {children}
    </TopBannerContext.Provider>
  )
}

export const TopBannerPortal = () => {
  const [banner, _setBanner] = useContext(TopBannerContext)

  return banner
}

// Holds a single banner slot (same limitation as BreadcrumbNavigation) — if
// two TopBanners are mounted at once, the later one wins.
export const TopBanner = ({ children }: { children: ReactNode }) => {
  const [_banner, setBanner] = useContext(TopBannerContext)

  // Callers should memoize `children` (e.g. via useMemo) — a new element
  // reference on every render keeps re-running this effect, repeatedly
  // clearing and re-setting the banner.
  useEffect(() => {
    setBanner(children)
    return () => setBanner(null)
  }, [children, setBanner])

  return <></>
}
